import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import MonthlyDonationsByBloodGroupChart from "./MonthlyDonationsByBloodGroupChart";

// Static data for monthly donations by blood group
const STATIC_BLOOD_GROUP_DATA = {
  months: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  bloodGroups: {
    "A+": [45, 52, 48, 55, 62, 58, 50, 65, 60, 70, 68, 75],
    "A-": [12, 15, 10, 18, 14, 16, 13, 17, 15, 20, 18, 22],
    "B+": [38, 42, 35, 45, 50, 48, 40, 52, 47, 55, 53, 60],
    "B-": [8, 10, 7, 12, 9, 11, 8, 13, 10, 15, 12, 16],
    "AB+": [15, 18, 14, 20, 22, 19, 16, 23, 20, 25, 24, 28],
    "AB-": [5, 6, 4, 7, 6, 5, 4, 8, 6, 9, 7, 10],
    "O+": [55, 62, 58, 68, 75, 70, 60, 78, 72, 85, 80, 90],
    "O-": [18, 22, 16, 25, 20, 23, 18, 27, 22, 30, 26, 32],
  },
};

const MonthlyDonationsByBloodGroupWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={12} lg={12}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Monthly Donations by Blood Group")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <MonthlyDonationsByBloodGroupChart data={STATIC_BLOOD_GROUP_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default MonthlyDonationsByBloodGroupWrapper;
